import qs from 'qs';
import { ServiceCategory } from '@prisma/client';
import API_URL from '../apiconfig';
import { ReportsReturn, TransactionType } from '../types/reports';
import axios from './api';

type ReportDataParams = {
  startDate: string | Date;
  endDate: string | Date;
  businessId: string;
  employeeId: string[];
  dateType: 'payment' | 'appointment';
  transactionType?: TransactionType;
  includeOrders?: boolean;
  includeInactiveEmployees?: boolean;
  service?: ServiceCategory;
  tripIds?: string[];
  isAllArtistsSelected?: boolean;
};

export async function fetchCompleteReportData(query: ReportDataParams) {
  const commonRequestConfig = {
    params: query,
    paramsSerializer: (params: Record<string, any>) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  };

  try {
    const response = await axios
      .get(`${API_URL}/v1/reports`, commonRequestConfig)
      .catch(() => {
        throw new Error('Error fetching report data');
      });

    return response.data.result as ReportsReturn;
  } catch (errorAny) {
    const error = errorAny as any;

    // If error message is one of the specific errors, propagate it up.
    if (error.message && error.message.startsWith('Error fetching')) {
      throw error;
    } else {
      // General error message
      throw new Error('Cannot fetch report data');
    }
  }
}
